export default {
  label: {
    duplicateCardLabel: 'Duplicate',
    filterCardLabel: 'Filter',
    resizeCardLabel: 'Resize',
    deleteCardLabel: 'Remove',
    expandCardLabel: 'Expand',
  },
};
